import { useQuery } from 'react-query';
import { MessageDetails } from './types';
import { useApiGet } from 'utils/hooks';

export const useMessageDetails = (id: string) => {
  const fetchMessageDetails = useApiGet(`/message/${id}`);
  return useQuery<MessageDetails, Error>(['messageDetails'], fetchMessageDetails);
};
